/**
 * Used on \ResourcePackages\Talon\MVC\Views\ImageGallery\List.ImageCarousel.cshtml
 * Creates Swiper carousel for image galleries
 */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

export function setupImageGallerySwiper(): void {
  const galleryContainers = document.querySelectorAll<HTMLElement>('.gallery-carousel__container');

  galleryContainers.forEach((container) => {
    // Skip if already initialized
    if ((container as any).swiper) return;

    // Get the parent gallery carousel element
    const galleryCarousel = container.closest('.gallery-carousel');
    if (!galleryCarousel) return;

    // Find navigation and pagination elements in parent
    const nextEl = galleryCarousel.querySelector('.swiper-button-next') as HTMLElement | null;
    const prevEl = galleryCarousel.querySelector('.swiper-button-prev') as HTMLElement | null;
    const paginationEl = galleryCarousel.querySelector('.swiper-pagination') as HTMLElement | null;

    const swiper = new Swiper(container, {
      modules: [Navigation, Pagination, A11y],
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 10,
      loop: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,

      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },

      pagination: {
        el: paginationEl,
        clickable: true,
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 30,
        },
      },

      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    });

    // Force update after a frame to fix width calculation issues
    requestAnimationFrame(() => {
      swiper.update();
    });
  });
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupImageGallerySwiper);
} else {
  setupImageGallerySwiper();
}

// Force update all swipers after window load to fix any layout issues
window.addEventListener('load', () => {
  const containers = document.querySelectorAll<HTMLElement>('.gallery-carousel__container');
  containers.forEach((container) => {
    const swiper = (container as any).swiper;
    if (swiper) {
      swiper.update();
    }
  });
});